import cloneDeep from 'lodash/cloneDeep'

export default (state = [], action) => {
  let { type, payload } = action
  let newState = cloneDeep(state)
  switch (type) {
    case 'LINES_SET':
      return payload
    case 'LINE_CREATE':
      newState.push(payload)
      return newState
    //return [payload, ...state]
    case 'LINE_UPDATE':
      return newState.map(item => {
        if (item.id != payload.id) return item
        const updated = Object.assign({}, item, payload)
        // Clear mapObj so render-lines recreates the Google Maps Polyline
        // with the new color/geometry instead of keeping the old one.
        delete updated.mapObj
        return updated
      })
    case 'LINE_DELETE':
      return newState.filter(item => item.id != payload)
    case 'LOGOUT':
      return []
    default:
      return state
  }
}
